import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { customerFinancialInfo } from 'global/Models/customerModel';
import { personBankAccount } from 'global/Models/personBankAccountModel';
import { bank, bankAccountType, bankAccout, customerCategory, customerUser, person, personProfilePicture, UserBranchesType, userProfile } from 'global/Models/userModel';
import { personBalanc } from 'global/Models/voucherModel';
import { walletRefundStatus } from 'global/Models/walletRefundModel';
import cookie from 'js-cookie';

const token = localStorage.getItem('sessionid');

export type userAllowed = { hasBankAccount: boolean; hasCustomer: boolean; isAllowed: boolean };
type reducerInitialState = {
  userProfile?: userProfile;
  userBranches?: UserBranchesType[];
  isLoggedIn: boolean;
  userPerson?: person;
  bankList?: bank[];
  bankAccountTypeList?: bankAccountType[];
  userAllowed: userAllowed;
  customerCategoryList?: customerCategory[];
  bankAccountList?: bankAccout[];
  personBankAccount?: personBankAccount[];
  walletRefundStatus?: walletRefundStatus[];
  customerUser?: customerUser;
  personTotalBalance?: personBalanc[];
  customerFinancialInfo?: customerFinancialInfo;
  personProfilePicture?: personProfilePicture;
};

const initialState: reducerInitialState = {
  userProfile: undefined,
  userBranches: undefined,
  isLoggedIn: !!token,
  userPerson: undefined,
  bankList: undefined,
  bankAccountTypeList: undefined,
  userAllowed: { hasBankAccount: true, hasCustomer: true, isAllowed: true },
  customerCategoryList: undefined,
  bankAccountList: undefined,
  personBankAccount: undefined,
  walletRefundStatus: undefined,
  customerUser: undefined,
  personTotalBalance: undefined,
  customerFinancialInfo: undefined,
  personProfilePicture: undefined,
};

const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, { payload }: PayloadAction<userProfile>) => {
      state.userProfile = payload;
    },
    setUserIsLoggedIn: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoggedIn = payload;
    },
    setUserPerson: (state, { payload }: PayloadAction<person>) => {
      state.userPerson = payload;
    },
    setBankList: (state, { payload }: PayloadAction<bank[]>) => {
      state.bankList = payload;
    },
    setBankAccountTypeList: (state, { payload }: PayloadAction<bankAccountType[]>) => {
      state.bankAccountTypeList = payload;
    },
    setBankAccountList: (state, { payload }: PayloadAction<bankAccout[]>) => {
      state.bankAccountList = payload;
    },
    userHandleLogout: (state) => {
      cookie.remove('token');
      cookie.remove('roles');
      localStorage.removeItem('token');
      localStorage.removeItem('roles');
      localStorage.removeItem('profile');
      localStorage.removeItem('isBranchUser');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('tokenExpiresAt');
      localStorage.clear();
      state.isLoggedIn = false;
      state.userProfile = undefined;
      state.userPerson = undefined;
      state.customerUser = undefined;
      state.bankAccountList = undefined;
      state.personBankAccount = undefined;
      state.walletRefundStatus = undefined;
      state.userAllowed = { hasBankAccount: true, hasCustomer: true, isAllowed: true };
      state.customerFinancialInfo = undefined;
      state.personTotalBalance = undefined;
    },
    setUserAllowed: (state, { payload }: PayloadAction<userAllowed>) => {
      state.userAllowed = payload;
    },
    setUserCustomerCategoryList: (state, { payload }: PayloadAction<customerCategory[]>) => {
      state.customerCategoryList = payload;
    },
    setPersonBankAccount: (state, { payload }: PayloadAction<personBankAccount[]>) => {
      state.personBankAccount = payload;
    },
    setWalletRefundStatus: (state, { payload }: PayloadAction<walletRefundStatus[]>) => {
      state.walletRefundStatus = payload;
    },
    setCustomerUser: (state, { payload }: PayloadAction<customerUser>) => {
      state.customerUser = payload;
    },
    setPersonTotalBalance: (state, { payload }: PayloadAction<personBalanc[]>) => {
      state.personTotalBalance = payload;
    },
    setCustomerFinancialInfo: (state, { payload }: PayloadAction<customerFinancialInfo>) => {
      state.customerFinancialInfo = payload;
    },
    setPersonProfilePicture: (state, { payload }: PayloadAction<personProfilePicture>) => {
      state.personProfilePicture = payload;
    },
    setUserLoginBranches: (state, { payload }: PayloadAction<UserBranchesType[]>) => {
      state.userBranches = payload;
    },
  },
});

export const {
  setUserProfile,
  setUserLoginBranches,
  setBankAccountList,
  setUserIsLoggedIn,
  userHandleLogout,
  setPersonBankAccount,
  setUserPerson,
  setBankList,
  setBankAccountTypeList,
  setUserAllowed,
  setUserCustomerCategoryList,
  setWalletRefundStatus,
  setCustomerUser,
  setPersonTotalBalance,
  setCustomerFinancialInfo,
  setPersonProfilePicture,
} = userReducer.actions;
export default userReducer.reducer;
